import { render, staticRenderFns } from "./SidebarNav.vue?vue&type=template&id=7ab6e02a&scoped=true&"
import script from "./SidebarNav.vue?vue&type=script&lang=js&"
export * from "./SidebarNav.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNav.vue?vue&type=style&index=0&id=7ab6e02a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab6e02a",
  null
  
)

export default component.exports